import { assign, EventObject, Machine } from 'xstate'

type RequestMachineEventTypeSchema = 'MAKE_CALL' | 'SET_CALL'

export interface RequestMachineContext {
  data: any
  error: string
  promise: Promise<any>
}

export type RequestMachineStates = {
  states: {
    idle: {}
    syncing: {}
    success: {}
    failed: {}
  }
}

export interface RequestMachineEventData extends EventObject {
  data: Promise<any> | any
  types: RequestMachineEventTypeSchema
}

export const requestMachine = Machine<
  RequestMachineContext,
  RequestMachineStates,
  RequestMachineEventData
>(
  {
    id: 'requestMachine',
    initial: 'idle',
    context: {
      data: undefined,
      error: '',
      promise: Promise.resolve(undefined),
    },
    states: {
      idle: {},
      syncing: {
        invoke: {
          id: 'awaitingPromise',
          src: 'waitForPromise',
          onDone: {
            target: 'success',
            actions: ['loadData'],
          },
          onError: {
            target: 'failed',
            actions: ['loadError'],
          },
        },
      },
      success: {},
      failed: {},
    },
    on: {
      SET_PROMISE: {
        target: 'syncing',
        actions: ['setPromise'],
      },
    },
  },
  {
    actions: {
      setPromise: assign((ctx, evt) => ({
        promise: evt.data,
      })),
      loadData: assign((ctx, evt) => ({
        data: evt.data,
      })),
      loadError: assign((ctx, evt) => ({
        data: evt.data,
        error: evt.data.message ?? '',
      })),
    },
    services: {
      waitForPromise: async (ctx) => await ctx.promise,
    },
  }
)
